import { getServerProps } from '../utils/serverProps';
import _map from 'lodash/map';

import {
  CHECK_EMAIL_CONFIRMED_RESPONSE,
  SHOW_UNKNOWN_ERROR_OCCURED,
  HIDE_UNKNOWN_ERROR_OCCURED,
  SHOW_COUNTRY_NOT_SUPPORTED,
  HIDE_COUNTRY_NOT_SUPPORTED,
  UPDATE_BUSINESS_IMAGE_URLS,
  UPDATE_IS_MOBILE,
} from '../components/partner/actionsPartner';

const defaultState = {
  ...getServerProps(),
  receivableCurrency: _map(getServerProps().receivableCurrency, (currency) => {
    return {
      value: currency,
      displayValue: currency,
    };
  }),
};

export default function application(state = defaultState, action = {}) {
  switch (action.type) {
    case CHECK_EMAIL_CONFIRMED_RESPONSE: {
      const isEmailConfirmed = action.payload === true;
      return {
        ...state,
        isEmailConfirmed,
      };
    }
    case SHOW_COUNTRY_NOT_SUPPORTED: {
      return {
        ...state,
        countryNotSupported: true,
      };
    }

    case HIDE_COUNTRY_NOT_SUPPORTED: {
      return {
        ...state,
        countryNotSupported: false,
      };
    }

    case SHOW_UNKNOWN_ERROR_OCCURED: {
      return {
        ...state,
        unknownError: true,
      };
    }

    case HIDE_UNKNOWN_ERROR_OCCURED: {
      return {
        ...state,
        unknownError: false,
      };
    }

    case UPDATE_BUSINESS_IMAGE_URLS: {
      return {
        ...state,
        businessImageUrls: {
          ...state.businessImageUrls,
          url: action.url,
        },
      };
    }

    case UPDATE_IS_MOBILE: {
      return {
        ...state,
        isMobile: action.isMobile,
      };
    }

    default:
      return state;
  }
}
